<template>
  <el-select
    v-model="value"
    class="select-remote"
    filterable
    remote
    reserve-keyword
    :placeholder="placeholderText"
    :remote-method="remoteMethod"
    :loading="loading"
  >
    <el-option
      v-for="item in options"
      :key="item.value"
      :label="item.label"
      :value="item.value"
    />
  </el-select>
</template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory'
const APIorganizations = RepositoryFactory.get('organizations')

export default {
  name: 'SelectRemote',
  props: {
    placeholderText: {
      type: String,
      default: 'Введите значение',
    },
    route: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      options: [],
      value: [],
      list: [],
      loading: false,
    }
  },
  watch: {
    value(newVal) {
      this.$emit('selectValue', newVal)
    },
  },
  methods: {
    remoteMethod(org_name) {
      if (org_name !== '') {
        this.loading = true
        APIorganizations.getOrganizations({ org_name })
          .then(response => {
            this.loading = false
            this.options = response.data.items.map(item => ({
              value: item.inn,
              label: item.name,
            }))
          })
          .catch(e => console.log(e))
      } else {
        this.options = []
      }
    },
  },
}
</script>
<style lang="sass">
.select-remote
  max-width: 350px
</style>
